import { render, staticRenderFns } from "./CategoryMenuOverlay.vue?vue&type=template&id=2d3fe6b2"
import script from "./CategoryMenuOverlay.vue?vue&type=script&lang=js"
export * from "./CategoryMenuOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports